import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Row, Col, Progress, Card, Alert, CardHeader, CardTitle, FormGroup, Label, Form, Input, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Button, ButtonDropdown, Table, Badge, Pagination, PaginationItem, PaginationLink, DropdownMenu, DropdownToggle, ButtonGroup, Dropdown, DropdownItem, FormText, InputGroup, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { Bar, Line } from "react-chartjs-2";
import classNames from 'classnames';
import { mapToCssModules } from 'reactstrap/lib/utils';
import classnames from "classnames";
import { RIEToggle, RIEInput, RIETextArea, RIENumber, RIETags, RIESelect } from 'riek'
import _ from 'lodash'
import Select from 'react-select';
import 'react-select/dist/react-select.min.css';
import Popover from 'react-awesome-popover';
import "react-awesome-popover/dest/react-awesome-popover.css";
import TagBindingStructure from '../../Support/TagBindingStructure';
const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';



const propTypes = {
    header: PropTypes.string,
    mainText: PropTypes.string,
    icon: PropTypes.string,
    color: PropTypes.string,
    variant: PropTypes.string,
    footer: PropTypes.bool,
    link: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    cssModule: PropTypes.object,
    systemVoltage: PropTypes.number,
    developer: PropTypes.bool,
    valuechangeinput: PropTypes.func,
};
const defaultProps = {
    header: 'Undefined',
    mainText: 'Undefined',
    icon: "fa fa-arrows-h",
    color: 'gray-100',
    variant: "0",
    link: "#"
};

class ComponentToggle extends Component {

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: '1',
            selectTagModal: false
        };
        this.valueChanged = this.valueChanged.bind(this);
        this.toggleSelectTagModal = this.toggleSelectTagModal.bind(this);
        this.saveChangesSelectTag = this.saveChangesSelectTag.bind(this);

    }


    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }
    valueChanged(e) {
        let keyName = Object.keys(e)[0];
        this.props.valuechangeinput(keyName, e[keyName]);
    }
    toggleSelectTagModal() {
        this.setState({
            selectTagModal: !this.state.selectTagModal
        });
    }
    saveChangesSelectTag(value) {
        this.setState({
            addAlarmTag: value.value
        });
    }

    convertBits(word = 0, bit = 0) {
        let arrayReturned = [];
        for (let i = 0; i < 15; i++)
            arrayReturned[i] = (word >> i) & 1;
        return arrayReturned[bit] === 1;
    }
    round(value, decimals) {
        return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    }
    checkTagBit(schema, returnText = true) {
        console.log('==================>')

        return this.props.iotData[schema.tag.id] || 0;
    }
    checkDesiredTagBit(schema, returnText = true) {
        console.log("TCL: ComponentToggle -> checkDesiredTagBit -> schema", schema)
        //console.log('test -> ' + this.convertBits(this.props.iotData[schema.tag.id],schema.tagBit.id));
        //console.log('schema.tag.id: ' + schema.tag.id);
        //console.log('here:' + this.props.iotData[schema.tag.id]);
        return this.props.desiredIotData[schema.tag.id] || 0;
    }


    render() {
        const { className, cssModule, header, mainText, icon, color, footer, link, children, variant, ...attributes } = this.props;

        const padding = (variant === '0' ? { card: "p-3", icon: "p-3", lead: "mt-2" } : (variant === "1" ? {
            card: "p-0", icon: "p-4", lead: "pt-3"
        } : { card: "p-0", icon: "p-4 px-5", lead: "pt-3" }));

        const card = { style: "card-body clearfix", color: color, icon: icon, classes: "" };
        card.classes = mapToCssModules(classNames(className, card.style, padding.card), cssModule);

        const lead = { style: "h5 mb-0", color: color, classes: "" };
        lead.classes = classNames(lead.style, 'text-' + card.color, padding.lead);

        const blockIcon = function (icon) {
            const classes = classNames(icon, 'bg-' + card.color, padding.icon, "font-2xl mr-3 float-left");
            return (<i className={classes}></i>);
        };

        let componentData = this.props.componentdata;
        const valueOfTag = this.checkTagBit(componentData.position, false);
        const valueOfDesiredTag = this.checkDesiredTagBit(componentData.position, false);
        console.log('valueOfTag ' + valueOfTag);
        console.log('valueOfDesiredTag ' + valueOfDesiredTag);
        return (
            <Card className={this.props.developer ? "mt-1" : ""}>
                <CardBody className={card.classes}>
                    {blockIcon(card.icon)}
                    <div className={lead.classes}>
                        <RIEInput
                            value={componentData.name}
                            change={this.valueChanged}
                            propName='name'
                            isDisabled={!this.props.developer}
                        />
                    </div>
                    <div className="text-muted text-uppercase font-weight-bold font-xs">
                        <RIEInput
                            value={componentData.desc}
                            change={this.valueChanged}
                            propName='desc'
                            isDisabled={!this.props.developer}
                        />
                    </div>
                    <hr />
                    <div className="row">
                        <Col col="6" sm="4" md="2" xl className="mb-3 mb-xl-0">
                            <Button onClick={() => this.props.writeControl(componentData.position.tag.id, componentData.position.tagBit.id, true)} block color={valueOfTag ? componentData.position.boolConfig.trueColor.id : 'light'} aria-pressed="true">{componentData.position.boolConfig.trueMsg}</Button>
                        </Col>
                        <Col col="6" sm="4" md="2" xl className="mb-3 mb-xl-0">
                            <Button onClick={() => this.props.writeControl(componentData.position.tag.id, componentData.position.tagBit.id, false)} block color={valueOfTag ? 'light' : componentData.position.boolConfig.falseColor.id} aria-pressed="true">{componentData.position.boolConfig.falseMsg}</Button>
                        </Col>
                    </div>

                    {this.props.developer && (
                        <div className="row pt-3">
                            <Col xs="10" sm="10" lg="10"></Col>
                            <Col xs="2" sm="2" lg="2">
                                <TagBindingStructure
                                    valueTag={componentData.position.tag}
                                    optionsTag={this.props.iodb}
                                    propNameTag="position.tag"
                                    valueBit={componentData.position.tagBit}
                                    optionsBit={this.props.tagBits}
                                    propNameBit="position.tagBit"
                                    change={this.valueChanged}
                                    componentIsBeingEdited={(status) => this.props.componentIsBeingEdited(status)}
                                    isBool={true}
                                    valueBoolConfig={componentData.position.boolConfig}
                                    propNameBoolConfig="position.boolConfig"
                                />
                            </Col>
                        </div>
                    )}
                </CardBody>
            </Card>
        )
    }
}

ComponentToggle.propTypes = propTypes;
ComponentToggle.defaultProps = defaultProps;


export default ComponentToggle;


// WEBPACK FOOTER //
// ./src/views/site/Developer/DeveloperOverviewRender/Components/Control/ComponentToggle.js